import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Billing } from '@typings';
import { PATH } from '@constants';

import { BillingLayout } from '@components/Layouts';

import { withSuspense } from './utils';

const BillingUsage = lazy(() => import('@pages/Billing/BillingUsagePage'));
const BillingCredits = lazy(() => import('@pages/Billing/BillingCreditsPage'));

export default function BillingRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate replace to={PATH.BILLING_USAGE} />} />
      <Route element={<BillingLayout />}>
        <Route path={Billing.Tab.Usage} element={withSuspense(BillingUsage)} />
        <Route
          path={Billing.Tab.Credits}
          element={withSuspense(BillingCredits)}
        />
      </Route>
      <Route path="*" element={<Navigate replace to={PATH.BILLING_USAGE} />} />
    </Routes>
  );
}
